/**
 * Feature toggles backed by Vite environment variables.
 * In browser builds, Vite statically replaces import.meta.env.VITE_* with literal values.
 * In Jest/Node tests, babel-plugin-transform-vite-meta-env maps them to process.env.
 */

export interface FeatureToggle {
    name(): string;
    envVar(): string;
    description(): string;
    isEnabled(): boolean;
}

const isTrueValue = (value: string | boolean | undefined): boolean =>
    value === 'true' || value === true;

export class FeatureToggles {
    static FEATURE_TOGGLE_DEPARTMENT_SHARE_SEND_EMAIL: FeatureToggle = {
        name() {
            return 'FEATURE_TOGGLE_DEPARTMENT_SHARE_SEND_EMAIL';
        },
        envVar() {
            return 'VITE_FEATURE_TOGGLE_DEPARTMENT_SHARE_SEND_EMAIL';
        },
        description() {
            return `Toggle for enabling/disabling the feature of triggering
            email sending when a department is shared.
            Toggle is off if either env var ${this.envVar()} is missing or set to 'false'.
            Toggle is on if env var ${this.envVar()} is set to 'true'`;
        },
        isEnabled() {
            return isTrueValue(
                import.meta.env.VITE_FEATURE_TOGGLE_DEPARTMENT_SHARE_SEND_EMAIL,
            );
        },
    };

    static FEATURE_TOGGLE_TRANSLATION_ENABLED: FeatureToggle = {
        name() {
            return 'FEATURE_TOGGLE_TRANSLATION_ENABLED';
        },
        envVar() {
            return 'VITE_FEATURE_TOGGLE_TRANSLATION_ENABLED';
        },
        description() {
            return `Toggle for enabling/disabling the visibility of the translation dropdown in the header.
            Toggle is off if either env var ${this.envVar()} is missing or set to 'false'.
            Toggle is on if env var ${this.envVar()} is set to 'true'`;
        },
        isEnabled() {
            return isTrueValue(
                import.meta.env.VITE_FEATURE_TOGGLE_TRANSLATION_ENABLED,
            );
        },
    };
}
